import { LANDING_OFFER_FROM_META_KEY, LANDING_BRANDED_OFFER_FROM_META, COMPANY_HOSTNAME } from "../constants.js";
import localstory from "localstory";
import { warning } from "./flog.js";
import { getCookie } from "./cookies.js";
import { getMarketingTrackingVariable } from "@flights/web-api-utils-universal";
import { FLYGRESOR_EXT_ORIGIN_PARAM_VALUES, GOOGLE_FLIGHTS_EXT_ORIGIN_PARAM_VALUES, GOOGLE_SEARCH_WIDGET_EXT_ORIGIN_PARAM_VALUES, KAYAK_EXT_ORIGIN_PARAM_VALUES, SKYSCANNER_EXT_ORIGIN_PARAM_VALUES, SKYSCANNERADS_EXT_ORIGIN_PARAM_VALUES, WEGO_EXT_ORIGIN_PARAM_VALUES } from "@flights/constants";
const isClient = process.env.BUILD_TARGET === "client";
const sessionStore = isClient && typeof window !== "undefined" && localstory(window.sessionStorage, "flights");
export const getExtOriginMarketingTrackingVariable = () => {
    if (isClient) {
        return sessionStore && sessionStore.get("ext-origin");
    }
    if (typeof window === "undefined")
        return undefined;
    return window?.__GLOBAL_CONTEXT__?.marketingTrackingVariables?.externalOrigin;
};
export const getSearchApiMarketingParams = () => {
    const mappedParams = {};
    const externalOrigin = getMarketingTrackingVariable("ext-origin");
    const externalForward = getMarketingTrackingVariable("ext-fwd");
    const salesCountry = getMarketingTrackingVariable("salesCountry");
    if (externalOrigin) {
        mappedParams["salesChannel"] = externalOrigin;
    }
    if (externalForward) {
        mappedParams["salesIdentifier"] = externalForward;
    }
    if (salesCountry) {
        mappedParams["salesCountry"] = salesCountry;
    }
    return mappedParams;
};
export const setMarketingTrackingVariables = (marketingTrackingVariables) => {
    if (!isClient || !sessionStore) {
        return;
    }
    marketingTrackingVariables?.aid && sessionStore.set("aid", marketingTrackingVariables.aid);
    marketingTrackingVariables?.label && sessionStore.set("label", marketingTrackingVariables.label);
    marketingTrackingVariables?.gclid && sessionStore.set("gclid", marketingTrackingVariables.gclid);
    marketingTrackingVariables?.gbraid && sessionStore.set("gbraid", marketingTrackingVariables.gbraid);
    marketingTrackingVariables?.auid && sessionStore.set("auid", marketingTrackingVariables.auid);
    marketingTrackingVariables?.adPlat && sessionStore.set("adplat", marketingTrackingVariables.adPlat);
    if (!marketingTrackingVariables?.adPlat) {
        try {
            const crossSellAdplat = getCookie("cross_sell_adplat_FLIGHT");
            if (crossSellAdplat) {
                sessionStore.set("adplat", crossSellAdplat);
            }
        }
        catch (error) {
            warning(`Cross sell adplat failed to be set from localStorage\n Error: ${error.message}`);
        }
    }
    marketingTrackingVariables?.externalCountry &&
        sessionStore.set("salesCountry", marketingTrackingVariables.externalCountry);
    marketingTrackingVariables?.externalCurrency &&
        sessionStore.set("salesCurrency", marketingTrackingVariables.externalCurrency);
    marketingTrackingVariables?.externalOrigin &&
        sessionStore.set("ext-origin", marketingTrackingVariables.externalOrigin);
    marketingTrackingVariables?.externalForward &&
        sessionStore.set("ext-fwd", marketingTrackingVariables.externalForward);
    marketingTrackingVariables?.externalSource && sessionStore.set("ext-src", marketingTrackingVariables.externalSource);
    marketingTrackingVariables?.externalTracking &&
        sessionStore.set("ext-tr", marketingTrackingVariables.externalTracking);
    marketingTrackingVariables?.distributionId &&
        sessionStore.set("distribution_id", marketingTrackingVariables.distributionId);
};
export const isOfMetaOrigin = () => {
    if (typeof window === "undefined")
        return false;
    if (window.location.host === COMPANY_HOSTNAME) {
        return !!window.__GLOBAL_CONTEXT__.isOfMetaOrigin;
    }
    return !!getExtOriginMarketingTrackingVariable();
};
export const isOfPPCOrigin = () => {
    if (typeof window === "undefined")
        return false;
    return !!window?.__GLOBAL_CONTEXT__.isPPC;
};
export const isDirect = () => !isOfMetaOrigin() && !isOfPPCOrigin();
export const isOfGoogleFlightsOrigin = () => GOOGLE_FLIGHTS_EXT_ORIGIN_PARAM_VALUES.includes(getExtOriginMarketingTrackingVariable());
export const isOfKayakOrigin = () => KAYAK_EXT_ORIGIN_PARAM_VALUES.includes(getExtOriginMarketingTrackingVariable());
export const isOfSkyScannerOrigin = () => SKYSCANNER_EXT_ORIGIN_PARAM_VALUES.includes(getExtOriginMarketingTrackingVariable());
export const isOfWegoOrigin = () => WEGO_EXT_ORIGIN_PARAM_VALUES.includes(getExtOriginMarketingTrackingVariable());
export const isOfFlygresorOrigin = () => FLYGRESOR_EXT_ORIGIN_PARAM_VALUES.includes(getExtOriginMarketingTrackingVariable());
export const isOfGoogleSearchWidgetOrigin = () => GOOGLE_SEARCH_WIDGET_EXT_ORIGIN_PARAM_VALUES.includes(getExtOriginMarketingTrackingVariable());
export const isOfSkyScannerAdsOrigin = () => SKYSCANNERADS_EXT_ORIGIN_PARAM_VALUES.includes(getExtOriginMarketingTrackingVariable());
export const getMetaLandingOfferToken = () => {
    if (!sessionStore) {
        return;
    }
    return sessionStore.get(LANDING_OFFER_FROM_META_KEY);
};
export const isMetaLandingOfferToken = (offerToken) => {
    if (!sessionStore) {
        return;
    }
    const landingOfferToken = getMetaLandingOfferToken();
    return landingOfferToken && offerToken.includes(landingOfferToken);
};
export const isMetaLandingBrandedOfferToken = (brandedOfferToken) => {
    if (!sessionStore) {
        return;
    }
    const landingOfferToken = getMetaLandingOfferToken();
    const landingBrandedOfferToken = sessionStore.get(LANDING_BRANDED_OFFER_FROM_META);
    return landingOfferToken && brandedOfferToken == landingBrandedOfferToken;
};
export function setLandingBrandedFareOfferToken(offerToken, brandedOfferToken) {
    if (!sessionStore) {
        return;
    }
    const isMeta = isOfMetaOrigin();
    const isLandingOfferToken = isMetaLandingOfferToken(offerToken);
    const isLandingBrandedOfferToken = isMetaLandingBrandedOfferToken(offerToken);
    if (isMeta && (isLandingOfferToken || isLandingBrandedOfferToken)) {
        sessionStore.set(LANDING_BRANDED_OFFER_FROM_META, brandedOfferToken);
    }
}
